import service from '../../http/axios';

// 查询待确认协议
export const queryWaitConfirmAgreement = service({
  url: '/yinghe-api/imageDataScienceAgree/getRefuseAgreement',
});

// 添加协议
export const createAgreement = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScienceAgree/addAgreement',
});

// 查询所有协议
export const getAgreement = service({
  url: '/yinghe-api/imageDataScienceAgree/getAgreement',
});
// 获取项目下所有协议
export const getBoundAgreement = service({
  url: '/yinghe-api/imageDataScienceAgree/getAgreementByImage',
});
// 解除绑定协议
export const removeBoundAgreement = service({
  method: 'DELETE',
  url: '/yinghe-api/imageDataScienceAgree/removeAgreementByImage',
});
//  绑定协议
export const createBindAgreement = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScienceAgree/addAgreementByImage',
});

// 查询所有协议状态
export const queryAgreementState = service({
  url: '/yinghe-api/imageDataScienceAgree/getAgreementState',
});
